import { core, dateUtil } from '@/core'
import Basic from '@basic'
import { Scrollbar } from '@bag'

const util = {
  template: {
    spinner(opt, tar) {
      return $('<div class="time-spinner has-seconds"></div>')
    },
    item(opt, tar) {
      return $('<li class="time-spinner__item"></li>')
    }
  },
  pullScroll(opt, tar, k) {
    const option = {
      tag: 'ul',
      viewClass: 'time-spinner__list',
      barClass: 'time-spinner__wrapper'
    }
    const scroll = new Scrollbar(option)
    scroll.scroll($.proxy(tar.handleScroll, tar, k))
    scroll.leave($.proxy(tar.handleLeave, tar, k))
    tar.unit.append(scroll.unit)
    return scroll
  },
  pullItem(opt, tar) {
    const items = tar.items
    items.map((one, k) => {
      const { scroll, keys } = one
      const div = $('<div></div>')
      const nodes = []
      for (let i = 0; i < keys; i++) {
        const text = String(i).padStart(2, '0')
        const li = this.template.item(opt, tar)
        li.text(text)
        li.click($.proxy(tar.click, tar, { clock: k, time: i }))
        div.append(li)
        nodes.push(li)
      }
      one.nodes = nodes
      scroll.slot = div.children()
    })
  },
  updater: {
    // 基本属性: date
    date (value, opt, tar, node) {

    },

    // 基本属性: 是否有秒
    showSeconds(value, opt, tar, node) {
      if (value) {
        tar.unit.addClass('has-seconds')
      } else {
        tar.unit.removeClass('has-seconds')
      }
    }
  }
}

export default class TimeSpinner extends Basic {
  constructor(opt) {
    super(opt)
    this.defaults = {
      showSeconds: true, // 基本功能: 是否有秒
      date: new Date(), // 基本属性: 设置时间
      max: null, // 基本属性: 最大时间
      min: null // 基本属性: 最小时间
    }
    this.events = {
      click: 'onClick',
      choose: 'onChoose',
      shown: 'onShown'
    }
    this.date = new Date()
    core.proxyApi(this) // 核心属性处理
    core.proxyEvent(this) // 核心事件处理
    this.settings = Object.assign({}, this.defaults, opt)
    this.init()
  }

  init() {
    const opt = this.settings
    const template = util.template.spinner(opt, this)
    const members = {}
    core.compileSymbol(template[0], members)
    this.members = members
    this.unit = template
    this.items = []
    this.items[0] = {
      scroll: util.pullScroll(opt, this, 0),
      keys: 24
    }
    this.items[1] = {
      scroll: util.pullScroll(opt, this, 1),
      keys: 60
    }
    if (this.showSeconds) {
      this.items[2] = {
        scroll: util.pullScroll(opt, this, 2),
        keys: 60
      }
    }
    util.pullItem(opt, this)
    core.update(util.updater, opt, this)
    this.bindInput()
  }

  bindInput() {
    // this.unit.click($.proxy(this.click, this))
  }

  startDate() {
    return dateUtil.getStartDateOfMonth(this.year, this.month)
  }

  getDateOfCell(year, month, date) {
    return new Date(year, month, date)
  }

  handleScroll(clock) {
    const target = event.target
    const keys = this.items[clock].keys
    let time = Math.round($(target).scrollTop() / 26)
    time > keys - 1 && (time = keys - 1)
    this.choose({ clock, time })
  }

  handleLeave(clock) {
    const scroll = this.items[clock * 1].scroll
    const keys = this.items[clock].keys
    let time = Math.round(scroll.scrollTop() / 26)
    time > keys - 1 && (time = keys - 1)
    scroll.scrollTop(time * 26)
  }

  onChoose(value) {
    const { clock, time } = value
    const target = this.items[clock].nodes[time]
    if ($(target).hasClass('disabled')) return false
    if (clock === 0) {
      this.hours = time
    } else if (clock === 1) {
      this.minutes = time
    } else if (clock === 2) {
      this.seconds = time
    } else {
      return false
    }
    target.siblings().removeClass('active')
    target.addClass('active')
    return this.date
  }

  onClick(value) {
    const { clock, time } = value
    const scroll = this.items[clock * 1].scroll
    scroll.scrollTop(time * 26)
    this.onChoose(value)
  }

  onShown(value) {
    if (value) {
      const time = [this.hours, this.minutes, this.seconds]
      const items = this.items
      items.map((item, i) => {
        item.scroll.scrollTop((time[i] || 0) * 26)
      })
    }
  }

  set hours(value) {
    this.date.setHours(value)
  }

  get hours() {
    return this.date.getHours()
  }

  set minutes(value) {
    this.date.setMinutes(value)
  }

  get minutes() {
    return this.date.getMinutes()
  }

  set seconds(value) {
    this.date.setSeconds(value)
  }

  get seconds() {
    return this.date.getSeconds()
  }
}
